const statusOptions = [
  { value: 'new', text: 'Novo' },
  { value: 'contacted', text: 'Em contato' },
  { value: 'qualified', text: 'Qualificado' },
  { value: 'archived', text: 'Arquivado' },
  { value: 'disqualified', text: 'Desqualificado' }
];

const classificationOptions = [
  { value: 'hot', text: 'Quente' },
  { value: 'warm', text: 'Morno' },
  { value: 'cold', text: 'Frio' }
];

const originOptions = ['Site', 'Indicação', 'LinkedIn', 'Evento', 'E-mail marketing', 'Outbound'];

export default async function tutorialLeadForm({ mode = 'edit' } = {}) {
  const readOnly = mode === 'view';

  return {
    element: 'autoform',
    parent: 'main',
    type: 'fieldset',
    mode,
    title: readOnly ? 'Visualizar lead' : 'Editar lead',
    isDialog: true,
    kill: true,
    data: {},
    buttons: [{ text: 'Fechar', close: true }],
    groups: [{
      legend: false,
      isGrid: true,
      content: [
        { element: 'text', name: 'lead', label: 'Lead', disabled: readOnly },
        { element: 'text', name: 'company', label: 'Empresa', disabled: readOnly },
        { element: 'text', name: 'owner', label: 'Responsável', disabled: readOnly },
        { element: 'combo', name: 'status', label: 'Situação', options: statusOptions, disabled: readOnly },
        { element: 'combo', name: 'classification', label: 'Classificação', options: classificationOptions, disabled: readOnly },
        { element: 'combo', name: 'origin', label: 'Origem', options: originOptions, disabled: readOnly },
        { element: 'date', name: 'entry_date', label: 'Entrada', disabled: readOnly },
        { element: 'date', name: 'last_activity', label: 'Última movimentação', disabled: readOnly }
      ]
    }]
  };
}
